import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { A11y } from "swiper";
import SwiperCore, { Autoplay, Pagination, Navigation } from "swiper/core";
import "swiper/css";
import "swiper/css/navigation";
import {
  InputGroup,
  InputLeftElement,
  Input,
  InputRightElement,
  Stack,
  Box,
  SimpleGrid,
  List,
  ListItem,
  ListIcon,
} from "@chakra-ui/react";
import { CheckIcon, EmailIcon } from "@chakra-ui/icons";
import { BsEnvelope, BsMailbox } from "react-icons/bs";
import { AiFillLock, AiOutlineUser } from "react-icons/ai";
// import "swiper/css/pagination";
// SwiperCore.use([Autoplay, Pagination, Navigation]);
import { MdCheckCircle, MdSettings, MdOutlineSell } from "react-icons/md";

export const Login = () => {
  return (
    <>
      <Container fluid className="py-5">
        <Container>
          <Row className="align-items-center">
            <Col lg="6">
              <div className="webkit p-2">
                <div>
                  <Image src={require("../../assets/LoginSignup.png")} />
                </div>
              </div>
            </Col>
            <Col
              lg="6"
              className="shadow-lg rounded-2xl shadow-gray-50 py-14 px-3 mt-4"
            >
              <div className="webkit">
                <div className="border-b-black border-b-4 pb-1 inline-block">
                  <h2 className="colorGreen font-semibold text-4xl">Login</h2>
                </div>
              </div>
              <div className="d-flex flex-col gap-3 py-6">
                <div>
                  <fieldset className="py-4">
                    <Stack spacing={4}>
                      <InputGroup>
                        <InputLeftElement pointerEvents="none">
                          <AiOutlineUser size={20} className="text-gray-400" />
                        </InputLeftElement>
                        <Input
                          className="py-2"
                          type="email"
                          placeholder="Email"
                        />
                      </InputGroup>

                      <InputGroup>
                        <InputLeftElement pointerEvents="none">
                          <AiFillLock size={20} className="text-gray-400" />
                        </InputLeftElement>
                        <Input
                          className="py-2"
                          type="password"
                          placeholder="Password"
                        />
                      </InputGroup>
                      <h2 className="colorGreen font-medium text-base text-right">
                        Forgot Password ?
                      </h2>
                    </Stack>
                  </fieldset>
                </div>
                <div className="webkit">
                  <button
                    className="btn btn--form py-2 font-semibold  w-full"
                    type="submit"
                    value="Log in"
                  >
                    Log in
                  </button>
                  <p className="colorGreen font-medium text-base py-3">
                    <span className="text-gray-500">New User ? </span>Signi up
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <Container>
          <Row className="align-items-center mt-4">
            <Col lg="6">
              <div className="p-2">
                <SimpleGrid>
                  <h2 className="colorGreen font-extrabold text-4xl">
                    Sawari Advantages
                  </h2>
                  <List py={3}>
                    <ListItem className="text-gray-500 text-xl">
                      <ListIcon as={MdCheckCircle} className="text-black" />
                      Lorem ipsum dolor sit
                    </ListItem>
                    <ListItem className="text-gray-500 text-xl">
                      <ListIcon as={MdCheckCircle} className="text-black" />
                      Lorem ipsum dolor sit
                    </ListItem>
                    <ListItem className="text-gray-500 text-xl">
                      <ListIcon as={MdCheckCircle} className="text-black" />
                      Lorem ipsum dolor sit
                    </ListItem>
                    <ListItem className="text-gray-500 text-xl">
                      <ListIcon as={MdCheckCircle} className="text-black" />
                      Lorem ipsum dolor sit
                    </ListItem>
                    <ListItem className="text-gray-500 text-xl">
                      <ListIcon as={MdCheckCircle} className="text-black" />
                      Lorem ipsum dolor sit
                    </ListItem>
                    <ListItem className="text-gray-500 text-xl">
                      <ListIcon as={MdCheckCircle} className="text-black" />
                      Lorem ipsum dolor sit
                    </ListItem>
                  </List>
                </SimpleGrid>
              </div>
            </Col>
            <Col lg="6">
              <div className="webkit p-2">
                <button
                  className="btn text-white py-3 font-semibold w-80 bg-black"
                  type="submit"
                  value="Log in"
                >
                  Log in
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
};
